const Statistics = Mach.requireModule('Statistics');

let CID = '';

const mv = (bid: string, val = {}) => {
  Statistics.view(CID, bid, val);
};

const mc = (bid: string, val = {}) => {
  Statistics.click(CID, bid, val);
};

export const Lx = {
  setCid: (cid: string) => {
    CID = cid;
  },

  // 关闭按钮点击
  closeBtnMc: (val = {}) => {
    mc('b_sailor_c_pt35kp32_mc', val);
  },

  // 弹窗曝光
  refundMethodViewMv: (val = {}) => {
    mv('b_sailor_c_dp8h0upe_mv', val);
  },

  // 确认按钮点击事件
  refundMethodConfimBtnMc: (val = {}) => {
    mc('b_sailor_c_dp8h0upe_mc', val);
  },

  // 退款方式选择
  refundMethodItemMc: (val = {}) => {
    mc('b_sailor_c_2b638dym_mc', val);
  },
};
